export const UPDATE_SERVER_SETTINGS_REQUEST = 'UPDATE_SERVER_SETTINGS_REQUEST';

export const updateServerSettingsRequest = ( updateData: {} ) => ({
    type: UPDATE_SERVER_SETTINGS_REQUEST,
    payload: { updateData }
});
